import * as React from "react";
import { Plus, FilePlus } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { ProjectSearchList } from "./ProjectSearchList";
import { WorkPillExecution } from "../../../types/navigationTypes";

interface ProjectSelectorModalProps {
  isOpen: boolean;
  onClose: () => void;
  projects: WorkPillExecution[];
  searchTerm: string;
  onSearchChange: (term: string) => void;
  onSelectProject: (executionId: string) => void;
  selectedExecutionId?: string;
  onCreateProject: () => void;
  onCreateBlankProject: () => void;
  selectedWorkPill: string;
  onWorkPillChange: (workPill: string) => void;
  uniqueWorkPills: string[];
  sortBy: 'newest' | 'oldest';
  onSortByChange: (sort: 'newest' | 'oldest') => void;
}

export const ProjectSelectorModal: React.FC<ProjectSelectorModalProps> = ({
  isOpen,
  onClose,
  projects,
  searchTerm,
  onSearchChange,
  onSelectProject,
  selectedExecutionId,
  onCreateProject,
  onCreateBlankProject,
  selectedWorkPill,
  onWorkPillChange,
  uniqueWorkPills,
  sortBy,
  onSortByChange
}) => {
  return (
    <Dialog open={isOpen} onOpenChange={(open) => !open && onClose()}>
      <DialogContent className="p-0 gap-0 max-w-[400px] h-[550px] flex flex-col overflow-hidden bg-white">
        <DialogHeader className="px-4 py-3 border-b border-border bg-white shrink-0">
          <DialogTitle className="text-base font-semibold">Select Project</DialogTitle>
        </DialogHeader>
        
        <div className="flex-1 overflow-hidden relative">
          <ProjectSearchList 
            projects={projects}
            searchTerm={searchTerm}
            onSearchChange={onSearchChange}
            onSelectProject={onSelectProject}
            selectedExecutionId={selectedExecutionId}
            selectedWorkPill={selectedWorkPill}
            onWorkPillChange={onWorkPillChange}
            uniqueWorkPills={uniqueWorkPills}
            sortBy={sortBy}
            onSortByChange={onSortByChange}
          />
        </div>

        <div className="p-3 border-t border-border bg-slate-50 flex gap-2 shrink-0">
          <Button 
            variant="outline" 
            className="flex-1 gap-2 bg-white text-xs h-9"
            onClick={onCreateBlankProject}
          >
            <FilePlus className="w-4 h-4" />
            Blank Project
          </Button>
          <Button 
            variant="default" 
            className="flex-1 gap-2 text-xs h-9"
            onClick={onCreateProject}
          >
            <Plus className="w-4 h-4" />
            New Project
          </Button>
        </div>
      </DialogContent>
    </Dialog>
  );
};
